"use client";

import { useSurvey } from "./survey-provider";
import posthog from "posthog-js";

export function SurveyCTAButton() {
  const { openSurvey } = useSurvey();

  const handleClick = () => {
    posthog.capture("unlock_profile_clicked", {
      page_url: typeof window !== "undefined" ? window.location.pathname : undefined,
    });
    openSurvey();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="inline-flex items-center gap-2 rounded bg-zinc-900 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-zinc-800"
    >
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
      Unlock full profile
    </button>
  );
}
